<template>
  <div @click="handleGlobalClick" style="height:70vh;">
    <div style="display: flex;justify-content: space-between">
      <div>
        <el-button type="danger" icon="el-icon-back" @click="$router.back()"></el-button>
        <el-button type="danger" icon="el-icon-plus" @click="addRow()">行</el-button>
        <el-button type="danger" icon="el-icon-plus" @click="addColumn">列</el-button>
        <el-button type="danger" icon="el-icon-cpu"></el-button>
        <el-popover
            placement="top"
            title="动态变量"
            width="300"
            trigger="hover">
          <div>
            <div style="display: flex;flex-wrap: wrap;justify-content: space-around">
              <div style="width: 30%;margin-bottom: 6px" v-for="(item,index) in performanceVariables" :key="index">
                <el-tooltip class="item" effect="dark" :content="'如文本中存在 '+item.dictValue+' 系统将替换为动态的：'+item.dictLabel" placement="top">
                  <el-tag style="width: 100%" type="danger">{{item.dictValue}}</el-tag>
                </el-tooltip>
              </div>
              <div style="width: 30%"></div>
              <div style="width: 30%"></div>
            </div>
            <el-image :preview-src-list="['https://minio.yanhuotiyu.com/yhoss/web/coach/20250618/2025/6/18/2025_06_1816_18_20198621b416530084c5e553aa57c0895.png']"
                src="https://minio.yanhuotiyu.com/yhoss/web/coach/20250618/2025/6/18/2025_06_1816_18_20198621b416530084c5e553aa57c0895.png"></el-image>

          </div>

          <el-button slot="reference" style="margin-left: 10px" type="danger">?</el-button>
        </el-popover>
      </div>
      <el-button type="danger" icon="el-icon-check" @click="createdDialog = true"></el-button>
    </div>
    <el-table :header-row-style="{ height: '10px !important' }" :cell-style="{ padding: '0' }"
              :span-method="mergeMethod" style="margin-top: 20px" empty-text="请点 + 行！" class="table"
              :data="this.tableData" border :row-style="{backgroundColor: '#FFFFFF'}" :highlight-selection-row="false"
              ref="tableRef">
      <el-table-column align="center" v-for="(item, index) in columnLength" :key="index" >
        <template #header>
          {{columnName[index]}}
        </template>
        <template #default="scope">
          <div @contextmenu.prevent="scope.row[index].setDialog = true" @click.stop>
            <el-popover placement="top" width="220" trigger="manual" v-model="scope.row[index].setDialog">
              <div>
                <div class="flex-between">
                  <div>Id:</div>
                  <el-input style="width: 100px"
                            @blur="inputId($event, scope.row[index])"
                            @input="tempValue = $event" :value="tempValue || scope.row[index].id"   size="mini"></el-input>
                </div>
                <div class="flex-between">
                  <div>总得分:</div>
                  <el-select v-model="scope.row[index].isScore" size="mini" placeholder="请选择" clearable style="width: 100px">
                    <el-option label="是" :value="1"/>
                  </el-select>
                </div>
                <div class="flex-between">
                  <div>只读: </div>
                  <el-switch v-model="scope.row[index].readOnly" size="mini" :active-value="true" :inactive-value="false"></el-switch>
                </div>
                <div class="flex-between">
                  <div>字体颜色:</div>
                  <el-color-picker v-model="scope.row[index].fontColor" size="mini"></el-color-picker>
                </div>
                <div class="flex-between">
                  <div>背景颜色:</div>
                  <el-color-picker v-model="scope.row[index].backGroundColor" size="mini"></el-color-picker>
                </div>
                <div class="flex-between">
                  <div>大小：</div>
                  <el-slider style="margin:0 4px;width: 70%;" :format-tooltip="sizeTooltip" v-model="scope.row[index].fontSize"></el-slider>
                </div>
                <div class="flex-between">
                  <div>粗细：</div>
                  <el-slider style="margin:0 4px;width: 70%;" :step="100" :max="900" :format-tooltip="weightTooltip" v-model="scope.row[index].fontWeight"></el-slider>
                </div>
                <div style="margin-top: 6px;display: flex;justify-content: center">
                  <el-radio-group v-model="scope.row[index].textAlign" size="mini">
                    <el-radio-button label="left">靠左</el-radio-button>
                    <el-radio-button label="center">居中</el-radio-button>
                    <el-radio-button label="right">靠右</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <template #reference>
                <div @mouseenter="mouseenterCell()" @mouseleave="mouseleaveCell()"
                     class="input-content-father" :style="';background-color:'+scope.row[index].backGroundColor">
                  <div class="input-content" @input="scope.row[index].content = $event.target.innerHTML"
                      contenteditable style="flex: 1;"
                       :style="'color:'+scope.row[index].fontColor+
                    ';background-color:'+scope.row[index].backGroundColor+
                    ';text-align: '+scope.row[index].textAlign+
                    ';font-size: '+scope.row[index].fontSize+'px'+
                    ';font-weight: '+scope.row[index].fontWeight"></div>
                </div>
              </template>
            </el-popover>
            <!-- 行高拖拽手柄 -->
            <div class="resize-handle" @mousedown="startResize(scope.$index)"></div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
        title="新增模板"
        :visible.sync="createdDialog"
        width="800px">
      <div  v-loading="createdLoading">
        <el-form label-position="top" :model="createdItem" :rules="rules" ref="formRef" label-width="110px" class="demo-ruleForm">
          <el-row>
            <el-col :span="11">
              <el-form-item label-width="100px" label="模板名称" prop="name">
                <el-input style="width: 280px"
                    placeholder="请输入名称"
                    v-model="createdItem.name"
                    clearable>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label-width="100px" label="可用成员" prop="coachList">
                <el-cascader collapse-tags style="width: 280px" ref="cascaderRef"
                             :options="deptUserTree" v-model="createdItem.coachList"
                             :props="{ multiple: true,label:'name',value:'id'}"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="createdDialog = false">取 消</el-button>
    <el-button type="danger" v-loading="createdLoading" @click="confirm">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
import {createdPerformanceTemplate} from "../../../../api/performance/performance";
import {selectDeptAndUserTree} from "../../../../api/contacts/dept";
import {selectOaDictByType} from"../../../../api/contacts/dict";
export default {
  name: "CreatedPerformanceTemplate",
  data() {
    const changePeople = (rule, value, callback) => {
      const form = this.createdItem;
      if (form.coachList && form.coachList.length>0){
        callback();return
      }
      callback(new Error('请选择可用人员！'));
    };
    return {
      createdItem:{
        name:"",
        coachList:[],
        list:[]
      },
      rules: {
        name: [{required: true, message: "请输入名称！", trigger: "blur"}],
        coachList: [{ validator: changePeople, trigger: 'blur' }],//打卡设置的自定义表单验证
      },
      performanceVariables:[],
      createdLoading:false,
      deptUserTree:[],
      createdDialog:false,
      columnName:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      columnLength: 4,
      tableData: [],
      tempValue:"",
      focusCellItem:{rowIndex:null,columnIndex:null},
      rowIdCounter: 1000,
      // 存储每行的高度信息
      rowHeights: {},
      // 拖拽状态
      isResizing: false,
      currentRowIndex: null,
      startY: 0,
      initialHeight: 0,
    }
  },
  mounted() {
    // 监听鼠标释放事件
    document.addEventListener('mouseup', this.stopResize);
    document.addEventListener('mousemove', this.resizeRow);
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('mouseup', this.stopResize);
    document.removeEventListener('mousemove', this.resizeRow);
  },
  methods: {
    inputId(value, rowData) {
      if (this.tempValue != null && this.tempValue!=''){
        rowData.id = this.tempValue;
      }
      this.tempValue = ''; // 清空临时值
    },
    /**
     * 处理选择的教练数据
     */
    coachDispose(){
      let list = [];
      const ref = this.$refs.cascaderRef;
      const checkedNodes = ref.getCheckedNodes();
      checkedNodes.forEach((node) => {
        if (node.data.type == 1){//只保留用户不保留部门
          list.push({coachId: node.value,coachName:node.label})
        }
      });
      this.createdItem.coachList = list;
    },
    handleGlobalClick() {
      for (const row of this.tableData) {
        for (const column of row) {
          column.setDialog = false;
        }
      }
    },
    sizeTooltip(val) {
      return ` ${val}px`
    },
    weightTooltip(val) {
      return ` ${val}`
    },
    mouseenterCell(){
      console.log("鼠标移入")
    },
    mouseleaveCell(){
      console.log("鼠标移出")
    },
    /**
     * 新增行
     */
    addRow() {
      const rowId = ++this.rowIdCounter;
      let length = this.columnLength;
      const newRow = Array.from({ length }, () => ({
        id: rowId,
        content: "",
        backGroundColor: "#FFFFFF",
        borderColor:"#ebeef5",
        textAlign: "center",
        fontSize: 14,
        setDialog:false,
        height:30,
        isScore:null,
        readOnly:false,
        fontWeight: 400,
        fontColor: '#303133'
      }));
      this.tableData = [...this.tableData, newRow];
      // 初始化新行的高度
      this.$nextTick(() => {
        const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
        this.rowHeights[rows.length - 1] = rows[rows.length - 1].offsetHeight;
      });
    },
    addColumn(){
      const rowId = ++this.rowIdCounter;
      this.tableData.forEach((item,index) =>{
        item.push({ id: rowId, content: "",backGroundColor:"#FFFFFF",textAlign:"center",fontSize:14,fontWeight:400,fontColor:'#303133'});
        this.tableData[index]=item;
      })
      this.columnLength = this.columnLength+1;
    },
    /**
     *合并单元格
     */
    mergeMethod({ row, column, rowIndex, columnIndex }) {
      const currentId = row[columnIndex].id;
      if (currentId >= 1000) return { rowspan: 1, colspan: 1 };
      const isTopLeftCell = (
          (columnIndex === 0 || row[columnIndex - 1].id !== currentId) &&
          (rowIndex === 0 || this.tableData[rowIndex - 1][columnIndex].id !== currentId)
      );
      if (!isTopLeftCell) return { rowspan: 0, colspan: 0 };

      let colspan = 1;//横向坐标
      for (let col = columnIndex + 1; col < row.length; col++) {
        if (row[col].id === currentId && row[col].id < 1000) colspan++;
        else break;
      }

      let rowspan = 1;//竖向坐标
      for (let rowIdx = rowIndex + 1; rowIdx < this.tableData.length; rowIdx++) {
        const cellId = this.tableData[rowIdx][columnIndex].id;
        if (cellId === currentId && cellId < 1000) rowspan++;
        else break;
      }
      return { rowspan, colspan };
    },
    // 开始拖拽
    startResize(rowIndex) {
      this.isResizing = true;
      this.currentRowIndex = rowIndex;
      this.startY = event.clientY;
      this.initialHeight = this.rowHeights[rowIndex] || 30;
      // 更改鼠标样式
      document.body.style.cursor = 'row-resize';
    },
    // 拖拽过程中
    resizeRow(event) {
      if (!this.isResizing) return;
      const offsetY = event.clientY - this.startY;
      const newHeight = Math.max(30, this.initialHeight + offsetY);
      // 更新行高
      this.rowHeights[this.currentRowIndex] = newHeight;
      // 找到对应的表格行并应用高度
      this.$nextTick(() => {
        const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
        if (rows[this.currentRowIndex]) {
          let tdList = rows[this.currentRowIndex].querySelectorAll("td");
          for (const td of tdList) {
            let textarea = td.querySelector("div .input-content-father");
            textarea.style.height = `${newHeight}px`;
          }
          rows[this.currentRowIndex].style.height = `${newHeight}px`;
        }
      });
    },
    // 结束拖拽
    stopResize() {
      this.isResizing = false;
      this.currentRowIndex = null;
      document.body.style.cursor = '';
      // 初始化新行的高度
      this.$nextTick(() => {
        const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
        if (rows.length>0){
          this.rowHeights[rows.length - 1] = rows[rows.length - 1].offsetHeight;
        }
        for (const row of rows) {
          let tdList = row.querySelectorAll("td");
          for (const td of tdList) {
            let textarea = td.querySelector("div .input-content-father");
            textarea.style.height = `${td.offsetHeight-1}px`;
          }
        }
      });
    },
    // 表格内容更新时重新执行合并单元格逻辑
    updateTable() {
      // 方法1：通过强制更新表格数据触发重新渲染
      this.tableData = [...this.tableData];
      // 方法2：使用 $nextTick 确保DOM更新后再执行布局
      this.$nextTick(() => {
        // 如果表格有引用，调用 doLayout 方法重新计算布局
        if (this.$refs.tableRef) {
          this.$refs.tableRef.doLayout();
        }
      });
    },
    confirm(){
      if (this.tableData.length<1){
        this.$notify({title: '警告', message: '未检测到模板数据，请先添加一行！', type: 'warning', offset: 40});return;
      }
      this.$refs.formRef.validate((valid) => {
        if (!valid) {return}
        this.coachDispose();
        this.createdLoading = true;
        const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
        rows.forEach((row, rowIndex) => {
          let tdList = row.querySelectorAll("td");
          tdList.forEach((column, columnIndex) => {
            let textarea = column.querySelector("div .input-content-father");
            const width = textarea.clientWidth;
            this.tableData[rowIndex][columnIndex].width = width;
            this.tableData[rowIndex][columnIndex].height = textarea.offsetHeight;
          });
        });
        let columnWidth = [];
        const headerTh = this.$refs.tableRef.$el.querySelectorAll('.el-table__header tr th');
        for (const th of headerTh) {
          columnWidth.push({width:th.clientWidth+1});
        }
        let rowHeights = [];
        delete this.rowHeights[null];
        for (const row of Object.values(this.rowHeights)) {
          console.log(row)
          if (row!=null){
            rowHeights.push({'height':row-1});
          }
        }
        columnWidth.length = columnWidth.length-1;
        this.createdItem.list = this.tableData;
        this.createdItem.list.push(columnWidth);
        this.createdItem.list.push(rowHeights);
        createdPerformanceTemplate(this.createdItem).then(val=>{
          this.createdLoading = false;
          if (val.status){
            this.createdDialog = false;
            this.tableData = [];
            this.$router.back();
            this.createdItem = {name:"",coachList: [],list: []};
            this.$notify({title: '新增成功', message: '新增模板成功！', type: 'success', offset: 40});
          }else {
            this.$notify.error({title: '新增失败', message: val.data, offset: 40});
          }
        })
        this.createdLoading = false;
      });
    },
  },
  created() {
    selectOaDictByType("performanceVariables").then(val=>{
      if (val.status == 200){
        this.performanceVariables = val.data;
      }
    })
    selectDeptAndUserTree().then(val=>{
      if (val.status == 200){
        this.deptUserTree=val.data;
      }
    })
  }
}
</script>
<style scoped>
/* 单元格内容样式 */
.cell-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 拖拽手柄样式 */
.resize-handle {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  height: 4px;
  cursor: row-resize;
  background-color: transparent;
  opacity: 0.5;
  transition: opacity 0.2s;
}
.flex-between{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input-content-father{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #7dcb57;
}
.resize-handle:hover {
  opacity: 1;
}
/* 为表格行添加样式 */
.el-table__body tr {
  transition: height 0.2s;
}
/* 使用/deep/或::v-deep穿透scoped样式 */
/deep/ .el-table .cell,
/deep/ .el-table th>.cell {
  padding: 0 !important;
}

/* 可选：移除单元格内内容的外边距 */
/deep/ .el-table .cell>div,
/deep/ .el-table .cell>span,
/deep/ .el-table .cell>button {
  margin: 0 !important;
}
/* 使用/deep/或::v-deep选择器覆盖默认样式 */
::v-deep .el-table__header-wrapper tr {
  height: 10px !important;
}
.table{
  width: 100%;
  border-radius: 10px;
  padding: 4px
}
::v-deep .el-table__header-wrapper th {
  padding: 2px 0; /* 减少内边距 */
}
::v-deep .el-cascader__tags{
  width: 68%;
  flex-wrap: nowrap;
}
</style>